export const PageHero = ({ eyebrow, title, subtitle, image, children }) => (
  <section className="relative overflow-hidden border-b border-line grain">
    {image && <img src={image} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-60" />}
    <div className="absolute inset-0 bg-gradient-to-r from-paper via-paper/90 to-paper/30" />
    <div className="container-x relative py-20 sm:py-28">
      <p className="eyebrow rise">{eyebrow}</p>
      <h1 className="rise mt-4 max-w-3xl text-4xl sm:text-5xl lg:text-6xl font-black uppercase leading-[0.95]" style={{ animationDelay: "80ms" }}>{title}</h1>
      {subtitle && <p className="rise mt-6 max-w-2xl text-base md:text-lg text-ink2" style={{ animationDelay: "160ms" }}>{subtitle}</p>}
      {children && <div className="rise mt-8 flex flex-wrap gap-4" style={{ animationDelay: "240ms" }}>{children}</div>}
    </div>
  </section>
);
